.toolbar {
  width: 18px;
  height: 18px;
  position: absolute;
  left: 8px;
  pointer-events: auto;
}
